import Rectangle from "slotworks/utils/geom/rectangle";

export function LimitBitmapText(text: PIXI.Text| PIXI.extras.BitmapText, limits: Rectangle) {
    if(!limits || !(text instanceof PIXI.extras.BitmapText)) return;
    const bitmapText = (text as any) as PIXI.extras.BitmapText;
    const fontSize: number = Number((bitmapText.font as any).size);
    let fontDecrease: number = 0;
    while(fontSize && bitmapText.textWidth > limits.width && fontDecrease < 40) {
        fontDecrease += 4;
        (bitmapText.font as any).size = fontSize - fontDecrease;
        (bitmapText as any).updateText();
    }
}


// WEBPACK FOOTER //
// ./src/model/do-utils.ts